import { createSelector } from '@ngrx/store';
import { ingredientsState } from '../root';

export const getProductSizeOptions = (productId: number) =>
    createSelector(ingredientsState, (ingredients) => ingredients?.find((ing) => ing.ProductId === productId)?.data?.ProductSizeOptions || null);
